import { render, staticRenderFns } from "./MicroaudienceComposition.vue?vue&type=template&id=50dfd083&"
import script from "./MicroaudienceComposition.vue?vue&type=script&lang=js&"
export * from "./MicroaudienceComposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports